export enum FormFieldSchemaType {
  STRING,
  NUMBER,
  DOB,
  BOOLEAN,
}
